import { createSlice } from '@reduxjs/toolkit';

const categorySlice = createSlice({
    name: 'category',
    initialState: {
        loading: false,
        categories: [],
        error: null,
        isCreated: false,
        isCategoryCreated: false,
        isUpdated: false,
        isCategoryUpdated: false,
        isDeleted: false,
        isCategoryDeleted: false,
    },
    reducers: {
        categoryRequest(state) {
            state.loading = true;
            state.error = null;
        },
        categoriesSuccess(state, action) {
            state.loading = false;
            state.categories = action.payload || [];
        },
        categoryCreateSuccess(state, action) {
            state.loading = false;
            state.categories = [...state.categories, action.payload];
            state.isCreated = true;
            state.isCategoryCreated = true;
        },
        categoryUpdateSuccess(state, action) {
            state.loading = false;
            const targetId = action.payload._id || action.payload.id;
            state.categories = state.categories.map(c =>
                String(c._id || c.id) === String(targetId) ? action.payload : c
            );
            state.isUpdated = true;
            state.isCategoryUpdated = true;
        },
        categoryDeleteSuccess(state, action) {
            state.loading = false;
            state.categories = state.categories.filter(c => 
                String(c._id || c.id) !== String(action.payload)
            );
            state.isDeleted = true;
            state.isCategoryDeleted = true;
        },
        categoryFail(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        clearCategoryError(state) {
            state.error = null;
        },
        clearCategoryCreated(state) {
            state.isCreated = false;
            state.isCategoryCreated = false;
        },
        clearCategoryUpdated(state) {
            state.isUpdated = false;
            state.isCategoryUpdated = false;
        },
        clearCategoryDeleted(state) {
            state.isDeleted = false;
            state.isCategoryDeleted = false;
        },
    }
});

export const {
    categoryRequest,
    categoriesSuccess,
    categoryCreateSuccess,
    categoryUpdateSuccess,
    categoryDeleteSuccess,
    categoryFail,
    clearCategoryError,
    clearCategoryCreated,
    clearCategoryUpdated,
    clearCategoryDeleted,
} = categorySlice.actions;

export default categorySlice.reducer;
